import React from 'react';
import clsx from 'clsx';
import { LeadStatus } from '@/services/leads.service';

const CONFIG: Record<
  LeadStatus,
  { label: string; bg: string; text: string; dot: string }
> = {
  new:        { label: 'New',        bg: 'bg-info-soft',    text: 'text-info',         dot: 'bg-info' },
  contacted:  { label: 'Contacted',  bg: 'bg-warning-soft', text: 'text-warning',      dot: 'bg-warning' },
  qualified:  { label: 'Qualified',  bg: 'bg-primary-soft', text: 'text-primary',      dot: 'bg-primary' },
  won:        { label: 'Won',        bg: 'bg-success-soft', text: 'text-success',      dot: 'bg-success' },
  lost:       { label: 'Lost',       bg: 'bg-danger-soft',  text: 'text-danger',       dot: 'bg-danger' },
  spam:       { label: 'Spam',       bg: 'bg-surface-alt',  text: 'text-text-muted',   dot: 'bg-text-muted' },
};

interface Props {
  status: LeadStatus;
  size?: 'sm' | 'md';
}

export const LeadStatusPill: React.FC<Props> = ({ status, size = 'md' }) => {
  const c = CONFIG[status] ?? CONFIG.new;
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full font-semibold',
        size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-0.5 text-xs',
        c.bg,
        c.text,
      )}
    >
      <span className={clsx('h-1.5 w-1.5 rounded-full', c.dot)} />
      {c.label}
    </span>
  );
};
